import type { NextPage } from "next";
import { LoginPage } from "../features/LoginPage";

const Home: NextPage = () => {
  return <LoginPage />;
};

export default Home;
